// ABOUTME: Admin Panel role enum, shared between server and client (client-safe, no heavy imports).
export const ADMIN_ROLES = ['super_admin', 'admin', 'user'] as const;
export type AdminRole = (typeof ADMIN_ROLES)[number];

export const isAdminRole = (value: unknown): value is AdminRole =>
  typeof value === 'string' &&
  (ADMIN_ROLES as readonly string[]).includes(value);
